import React from 'react'

const DashboardProfile = () => {
 return (
  <>
   <h1 className="text-primary">
   WELOCME TO THE DASHBOARD PAGE
   </h1>
  </>
 )
}

export default DashboardProfile
